import {routes} from "../data/routes";

export function resolveMetaTitle(normalizedLocation, t, defaultMetaTitle) {
	switch (normalizedLocation) {
		case routes.index:
			return t("meta_title_home");
		case routes.login:
			return `${defaultMetaTitle} - ${t("meta_title_login")}`;
		case routes.diary:
			return `${defaultMetaTitle} - ${t("meta_title_diary")}`;
		case routes.feedback:
			return `${defaultMetaTitle} - ${t("meta_title_feedback")}`;
		case routes.resources:
			return `${defaultMetaTitle} - ${t("meta_title_resources")}`;
		case routes.guide:
			return `${defaultMetaTitle} - ${t("meta_title_guide")}`;
		case routes.packages:
			return `${defaultMetaTitle} - ${t("meta_title_packages")}`;
		default:
			return defaultMetaTitle;
	}
}

export const checkMetaTitle = (location) => {
	const {useTranslation, useI18next} = require("gatsby-plugin-react-i18next");
	const {t} = useTranslation();
	const {language} = useI18next();

	const languagePattern = new RegExp(`^/${language}`);
	const normalizedLocation = location.replace(languagePattern, "");
	const defaultMetaTitle = t("defaultMetaTitle");

	return resolveMetaTitle(normalizedLocation, t, defaultMetaTitle);
};
